module.exports = __webpack_public_path__ + "img/gameshow5.b438858d.svg";